import { useEffect, useRef, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { IoMdRefresh } from "react-icons/io";
import { TfiAngleRight } from "react-icons/tfi";
import Dropdwon from "../layout/Dropdwon";
import List from "../layout/List";
import Listitem from "../layout/Listitem";

const ChooseCategory = () => {
  const [vehiclesDrop, setVehiclesDrop] = useState(false);
  const [carDrop, setCarDrop] = useState(false);
  const [bmwDrop, setBmwDrop] = useState(false);
  const [ciDrop, setCiDrop] = useState(false);
  const vehiclesRef = useRef();
  const carRef = useRef();
  const bmwRef = useRef();
  const ciRef = useRef();

  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      if (vehiclesRef.current.contains(e.target)) {
        setVehiclesDrop(true);
      } else {
        setVehiclesDrop(false);
      }
      if (carRef.current.contains(e.target)) {
        setCarDrop(true);
      } else {
        setCarDrop(false);
      }
      if (bmwRef.current.contains(e.target)) {
        setBmwDrop(true);
      } else {
        setBmwDrop(false);
      }
      if (ciRef.current.contains(e.target)) {
        setCiDrop(true);
      } else {
        setCiDrop(false);
      }
    });
  }, []);

  return (
    <div>
      <div>
        <h3 className="mt-6 font-pop text-xl font-medium text-textColor">
          Choose Catogery
        </h3>
        <div>
          <div className="mt-6 flex items-center gap-x-4">
            <Dropdwon
              dropRef={vehiclesRef}
              className="relative z-50 flex cursor-pointer items-center"
            >
              <div className="flex items-center gap-x-6">
                <img
                  className="h-8 w-8"
                  src="/assets/images/auction_listing/caricon.png"
                  alt="caricon"
                />
                <div className="flex items-center">
                  <p className="border-2 border-solid border-primary py-2.5 px-4 font-pop text-base font-medium text-black text-opacity-50">
                    Vehicles
                  </p>
                  <div className="bg-primary py-3.5 px-3.5 text-white">
                    <FaAngleDown className="h-5 w-5" />
                  </div>
                </div>
              </div>
              {vehiclesDrop && (
                <List className="absolute top-12 right-0 w-[210px] bg-white">
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Vehicles"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Vehicles"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Vehicles"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Vehicles"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Vehicles"
                  />
                </List>
              )}
            </Dropdwon>
            <Dropdwon
              dropRef={carRef}
              className="relative z-50 flex cursor-pointer items-center gap-x-3"
            >
              <div className="flex items-center gap-x-6">
                <IoMdRefresh className="h-6 w-6 text-[#2FE136]" />
                <div className="flex items-center">
                  <p className="border-2 border-solid border-primary py-2.5 px-4 font-pop text-base font-medium text-black text-opacity-50">
                    Cars
                  </p>
                  <div className="bg-primary py-3.5 px-3.5 text-white">
                    <FaAngleDown className="h-5 w-5" />
                  </div>
                </div>
              </div>
              {carDrop && (
                <List className="absolute top-12 right-0 w-[165px] bg-white">
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Cars"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Cars"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Cars"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Cars"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="Cars"
                  />
                </List>
              )}
            </Dropdwon>
            <Dropdwon
              dropRef={bmwRef}
              className="relative z-50 flex cursor-pointer items-center gap-x-3"
            >
              <div className="flex items-center gap-x-6">
                <IoMdRefresh className="h-6 w-6 text-[#2FE136]" />
                <div className="flex items-center">
                  <p className="border-2 border-solid border-primary py-2.5 px-4 font-pop text-base font-medium text-black text-opacity-50">
                    BMW
                  </p>
                  <div className="bg-primary py-3.5 px-3.5 text-white">
                    <FaAngleDown className="h-5 w-5" />
                  </div>
                </div>
              </div>
              {bmwDrop && (
                <List className="absolute top-12 right-0 w-[165px] bg-white">
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                </List>
              )}
            </Dropdwon>
            <Dropdwon
              dropRef={ciRef}
              className="relative z-50 flex cursor-pointer items-center gap-x-3"
            >
              <div className="flex items-center gap-x-6">
                <IoMdRefresh className="h-6 w-6 text-[#2FE136]" />
                <div className="flex items-center">
                  <p className="border-2 border-solid border-primary py-2.5 px-4 font-pop text-base font-medium text-black text-opacity-50">
                    320
                  </p>
                  <div className="bg-primary py-3.5 px-3.5 text-white">
                    <FaAngleDown className="h-5 w-5" />
                  </div>
                </div>
              </div>
              {ciDrop && (
                <List className="absolute top-12 right-0 w-[155px] bg-white">
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                  <Listitem
                    className="border-b border-solid border-darkGreen border-opacity-20 bg-white py-2 px-10 hover:bg-darkGreen hover:bg-opacity-10 hover:text-primary"
                    itemname="BMW"
                  />
                </List>
              )}
            </Dropdwon>
          </div>
          <div className="mt-3.5 flex items-center px-14 ">
            <List className="flex items-center">
              <Listitem
                title="Pretoria"
                className="font-regular font-pop text-sm text-darkGreen text-opacity-50"
              />
              <TfiAngleRight className="h-4 w-4 text-primary" />
            </List>
            <List className="flex items-center">
              <Listitem
                title="Elardus Park"
                className="font-regular font-pop text-sm text-darkGreen text-opacity-50"
              />
              <TfiAngleRight className="h-4 w-4 text-primary" />
            </List>
            <List className="flex items-center">
              <Listitem
                title="Vehicles"
                className="font-regular font-pop text-sm text-darkGreen text-opacity-50"
              />
              <TfiAngleRight className="h-4 w-4 text-primary" />
            </List>
            <List className="flex items-center">
              <Listitem
                title="Cars"
                className="font-regular font-pop text-sm text-darkGreen text-opacity-50"
              />
              <TfiAngleRight className="h-4 w-4 text-primary" />
            </List>
            <List className="flex items-center">
              <Listitem
                title="BMW"
                className="font-regular font-pop text-sm text-darkGreen text-opacity-50"
              />
              <TfiAngleRight className="h-4 w-4 text-primary" />
            </List>
            <p className="font-regular font-pop text-sm text-darkGreen text-opacity-50">
              2023 Bmw 330ci for sale in a very good condition
            </p>
          </div>
          <div className="w-[795px]">
            <h3 className="mt-8 mb-4 font-pop text-xl font-medium text-textColor">
              Title
            </h3>
            <input
              className="w-full rounded-md border border-solid border-[#CCD5D6] py-6 px-6"
              type="text"
              placeholder="Type here....."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseCategory;
